"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastRequest = void 0;
var NodeBaseRequest_1 = require("./NodeBaseRequest");
var BroadcastRequest = /** @class */ (function (_super) {
    __extends(BroadcastRequest, _super);
    function BroadcastRequest(baseUrl) {
        return _super.call(this, baseUrl) || this;
    }
    BroadcastRequest.prototype.broadcast = function (transaction) {
        var lang = 'en';
        return this.fetchJSON("broadcast/" + transaction + "?lang=" + lang.toLowerCase());
    };
    BroadcastRequest.prototype.broadcast64 = function (transaction) {
        var lang = 'en';
        return this.fetchJSON("broadcast64/" + transaction + "?lang=" + lang.toLowerCase());
    };
    BroadcastRequest.prototype.broadcastPost = function (raw) {
        var lang = 'en';
        return this
            .fetchJSON("broadcast?lang=" + lang.toLowerCase(), "POST", raw, { "content-type": "application/x-www-form-urlencoded" });
    };
    BroadcastRequest.prototype.broadcastPost64 = function (raw) {
        var lang = 'en';
        return this
            .fetchJSON("broadcast64?lang=" + lang.toLowerCase(), "POST", raw, { "content-type": "application/x-www-form-urlencoded" });
    };
    BroadcastRequest.prototype.telegram = function (transaction) {
        return this.fetchJSON("broadcasttelegram/" + transaction);
    };
    BroadcastRequest.prototype.telegramPost = function (raw) {
        return this.fetchJSON("broadcasttelegram", 'POST', raw, { 'content-type': 'application/x-www-form-urlencoded' });
    };
    return BroadcastRequest;
}(NodeBaseRequest_1.NodeBaseRequest));
exports.BroadcastRequest = BroadcastRequest;
